import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'

// Application identification console log
console.log(`
🛒 BANJINO'S E-COMMERCE SHOP (DTC)
📍 Domain: shop.banjinos.com
📂 Frontend: /frontend-dtc (DTC)
🎯 Purpose: Direct-to-consumer sales, shopping cart, product catalog
🚀 Starting application...
`);

// Configure axios defaults
const baseURL = import.meta.env.VITE_API_URL || (window.location.hostname.includes('.com') ? 'https://api.banjinos.com/api' : 'https://api.banjinos.dev/api')
const apiVersion = 'v1'
const apiGateway = 'dtc'

// Set base URL with versioning and gateway
axios.defaults.baseURL = `${baseURL}/${apiVersion}/${apiGateway}`

// Vuetify - Minimal configuration
import vuetify from './plugins/vuetify-minimal'


// Import Master Brand System (SCSS) - MUST be AFTER Vuetify to override
import './assets/scss/main.scss'

// Material Design Icons - Import after SCSS to ensure it's not overridden
import '@mdi/font/css/materialdesignicons.css'

// Brand tokens (storefront redesign) - last, so they win
import './styles/brand-tokens.scss'

// Pinia
import { createPinia } from 'pinia'

// Router
import router from './router'

const pinia = createPinia()

// Set up axios interceptors
axios.interceptors.response.use(
  response => response,
  error => {
    // Handle network errors (backend not running)
    if (error.code === 'ERR_NETWORK' || error.code === 'ECONNREFUSED') {
      console.warn('Backend not available - check server connection')
    }
    
    if (error.response?.status === 401) {
      // Check if it's a token expiration
      if (error.response.data?.code === 'TOKEN_EXPIRED' || 
          error.response.data?.error === 'Invalid authentication') {
        // Clear local storage
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        localStorage.removeItem('client')
        
        // Clear auth header
        delete axios.defaults.headers.common['Authorization']
        
        // Redirect to login
        router.push('/login')
      }
    }
    return Promise.reject(error)
  }
)

// Set auth header if token exists
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

const app = createApp(App)
  .use(vuetify)
  .use(pinia)
  .use(router)
  .mount('#app')

// Typography is now handled by the SCSS brand system
// No need for JavaScript font forcing
